import { useClientStorage } from 'customHooks/useClientStorage'
import { useEffect } from 'react'

export const useDetailsTabs = (
  initialTab?: 'geometryDetails' | 'attachmentDetails',
) => {
  const [detailTab, setDetailTab] = useClientStorage<
    'geometryDetails' | 'attachmentDetails'
  >('detailsTab', initialTab ?? 'geometryDetails')

  useEffect(() => {
    if (initialTab) {
      setDetailTab(initialTab)
    }
  }, [initialTab, setDetailTab])

  return {
    detailTab,
    setDetailTab,
  }
}
